<template>
  <div>
    <van-row class="bmTitle">
      <van-col span="24">
        <h2>{{ meetingName }}</h2>
      </van-col>
    </van-row>
    <van-row class="bmForm">
		
      <van-col span="24">
        <van-form @submit="onSubmit">
			<h3 class="bmlcTit">填写学分信息 <van-icon class="iconfont" class-prefix="icon" name="bianji" size="24" color="#e5b91c" />
			<div style="float: right;">
			  <van-button round block  type="default" @click="shsq">稍后申请</van-button>
			</div>
			</h3>
          <div class="formInput">
            <van-field
			v-if="this.zsbxy == false"
              v-model="name"
              name="name"
              placeholder="请填写姓名"
              label="姓名"
              clearable
              required
              :rules="[{ required: true, message: '请填写姓名' }]"
            />
          </div>
          <div class="formInput">
            <van-field
			v-if="this.zsbxy == false"
              v-model="age"
              name="age"
              placeholder="请填写年龄"
              label="年龄"
              maxlength='3'
              type="digit"
              clearable
              required
              :rules="[{ required: true, message: '请填写年龄' }]"
            />
          </div>
          <div class="formInput">
            <van-field
			v-if="this.zsbxy == false"
              name="sex"
              label="性别"
              required
            >
              <template #input>
                <van-radio-group v-model="sex" direction="horizontal">
                  <van-radio name="男">男</van-radio>
                  <van-radio name="女">女</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div class="formInput">
            <van-field
			v-if="this.zsbxy == false"
              v-model="titlegrade"
              is-link
              readonly
              name="titlegrade"
              label="职称"
              placeholder="请选择职称"
              required
              @click="showPicker_titlegrade = true"
              :rules="[{ required: true, message: '请选择职称' }]"
            />
            <van-popup v-model:show="showPicker_titlegrade" position="bottom">
              <van-picker
              show-toolbar
                :columns="columns_titlegrade"
                @confirm="onConfirm_titlegrade"
                @cancel="showPicker_titlegrade = false"
              />
            </van-popup>
          </div>
          <div class="formInput">
            <van-field
			v-if="this.zsbxy == false"
              v-model="gzdw"
              name="gzdw"
              placeholder="请填写单位标准全称"
              label="工作单位"
              clearable
              required
              :rules="[{ required: true, message: '请填写单位标准全称' }]"
            />
          </div>
          <!-- <div class="formInput">
            <van-field
			v-if="this.zsbxy == false"
              v-model="unitlocation"
              name="unitlocation"
              placeholder="请填写单位所在地"
              label="单位所在地"
              clearable
              required
              :rules="[{ required: true, message: '请填写单位所在地' }]"
            />
          </div> -->
          <!-- <div class="formInput">
            <van-field
			v-if="this.zsbxy == false"
              v-model="titlegrade"
              name="titlegrade"
              placeholder="请填写职称"
              label="职称"
              clearable
              required
              :rules="[{ required: true, message: '请填写职称' }]"
            />
          </div> -->
          <!-- <div class="formInput">
            <van-field
			v-if="this.zsbxy == false"
              v-model="department"
              name="department"
              placeholder="请填写科室/部门"
              label="科室/部门"
              clearable
              required
              :rules="[{ required: true, message: '请填写科室/部门' }]"
            />
          </div> -->
          <div class="formInput">
            <van-field
			v-if="this.zsbxy == false"
              name="isbasiclevel"
              label="是否来自基层（县及以下、社区等医疗卫生机构）"
              required
            >
              <template #input>
                <van-radio-group v-model="isbasiclevel" direction="horizontal">
                  <van-radio name="是">是</van-radio>
                  <van-radio name="否">否</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div class="formInput">
            <!-- <van-field
			v-if="this.zsbxy == false"
              v-model="province"
              name="province"
              placeholder="请填写所属省市"
              label="所属省市"
              clearable
              required
              :rules="[{ required: true, message: '请填写所属省市' }]"
            /> -->
            <van-field
			v-if="this.zsbxy == false"
              v-model="province"
              name="province"
              is-link
              readonly
              label="单位所在地（省）"
              placeholder="请填写单位所在地（省）"
              required
              @click="showPicker = true"
              :rules="[{ required: true, message: '请选择单位所在地（省）' }]"
            />
            <van-popup v-model="showPicker" round position="bottom">
              <van-area title="所属省市" :area-list="areaList" :columns-num="1" @confirm="onConfirmProvince" @cancel="showPicker = false" />
            </van-popup>
          </div>
          <div class="formInput">
            <van-field
				v-if="this.zsbxy == false"
              v-model="phone"
              name="phone"
              label="联系电话"
              placeholder="请输入联系电话"
              type="tel"
              clearable
              required
              maxlength="11"
              :rules="[{ pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, required: true, message: '联系电话格式错误' }]"
            />
          </div>
          <!-- <div class="formInput">
            <van-field
			v-if="this.zsbxy == false"
              name="islsxbfc"
              label="是否隶属于西部12省（区、市）范畴"
              required
            >
              <template #input>
                <van-radio-group v-model="islsxbfc" direction="horizontal">
                  <van-radio name="是">是</van-radio>
                  <van-radio name="否">否</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div> -->
          <div style="margin:30px 16px 16px;">
            <van-button round block  type="info" native-type="submit">下一步</van-button>
          </div>
          <!-- <div style="margin:20px 16px 16px;">
            <van-button round block  type="default" @click="shsq">稍后申请</van-button>
          </div> -->
        </van-form>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data';	
export default {
  data() {
    return {
      meetingName: this.$cookies.get('meetingName'),
      name:'',
      age:'',
      gzdw:'',
      // unitlocation:'',
      titlegrade:'',
      department:'',
      province:'',
      phone:'',
      sex:'',
      isbasiclevel:'',
      islsxbfc:'',
      sqxfEndTime:localStorage.getItem('sqxfEndTime'),
      showPicker:false,
      areaList:areaList,
      showPicker_titlegrade:false,
      columns_titlegrade:[
        {
          text: '副高及以上',
          value:'副高及以上'
        },
        {
          text:'中级',
          value:'中级'
        },
        {
          text:'初级',
          value:'初级'
        },
        {
          text:'乡村医生',
          value:'乡村医生'
        }
      ],
      IsAttr2:false,
      zsbxy:false
    };
  },
  methods: {
    shsq(){
      this.zsbxy = true;
    },
    onConfirm_titlegrade(value) {
      this.titlegrade = value.value;
      this.showPicker_titlegrade = false;
    },
    onConfirmProvince(value) {
      this.province = value.map(item => item.name).join('/');
      this.showPicker = false;
    },
    onSubmit(values) {
	  const formValue = JSON.parse(sessionStorage.getItem('values'));
      if(values.sex == ""){
        this.$toast.fail('请选择性别')
        return false;
      }else if(values.titlegrade == ""){
        this.$toast.fail('请选择职称')
        return false;
      }else if(values.isbasiclevel == ""){
        this.$toast.fail('请选择是否来自基层（县及以下、社区等医疗卫生机构）')
        return false;
      }
      // else if(values.islsxbfc == ""){
      //   this.$toast.fail('请选择是否隶属于西部12省（区、市）范畴')
      //   return false;
      // }
      const hyMeetingId = sessionStorage.getItem('meetingId');
	
	   if(this.zsbxy == false){
		  sessionStorage.setItem('meetingWyxf',JSON.stringify(values))
		  // this.$router.push('/Fpgl/index?meetingCode='+this.$route.query.meetingCode);
		}else{
			// this.$router.push('/Fpgl/index?meetingCode='+this.$route.query.meetingCode);
		}
		
		//跳过发票信息 2026-07-07
		formValue.isCharge = 1;
		formValue.attr2 = JSON.stringify(values)
		this.axios.post('/api/appweb/entered/fromAdd', formValue).then(res => {
		  if (res.data.status == 200) {
		    //订单报名费
		    var userOrderInfo = res.data.data;
		    var payMoney = userOrderInfo.payMoney;
		    if (payMoney) {
		        this.$cookies.set("cookies_meeting_order_payMoney", payMoney);
		    }
		    //订单号
		    var outTradeNo = userOrderInfo.outTradeNo;
		    if (outTradeNo) {
		        this.$cookies.set("cookise_order_outTradeNo", outTradeNo);
		    }
		    //订单id
		    var meetingPayorderId = userOrderInfo.meetingPayorderId;
		    if (meetingPayorderId) {
		        this.$cookies.set("cookies_meeting_order_key", meetingPayorderId);
		    }
		      this.$router.push('/charge/pay');
		  } else {
		    if (res.data.msg) {
		      this.$toast.fail(res.data.msg);
		    } else if(res.data.status == -1){
		      this.$toast.fail(res.data.message);
		    }
		    else {
		      this.$toast.fail(res.data.result.users[0].msg);
		    }
		  }
		})
	console.log(formValue);
    },
	
  }
};
</script>

<style>
.bmlcTit {
	font-size: 20px;
	font-weight: bold;
	margin-top: 0;
	margin-bottom: 20px;
	margin-left: 20px;
	margin-right: 20px;
	color: #0038b8;
	line-height: 40px;
}
.bmlcTit button{vertical-align: middle;}	
.bmForm {
  padding: 20px 0;
}
.bmTitle {
  padding: 10px 20px 30px;
  line-height: 40px;
  background: url(~@/assets/images/titlebg.png) no-repeat bottom center;
  background-size:  100% 100%;
  color:#fff;
  text-align: center;
}
.bmTitle h2 {
  font-weight: normal;
  margin-bottom: 0;
}
.hide {
  display: none;
}
.formInput {
  padding: 4px 0;
  margin:0 20px;
  border-bottom: 1px solid #e8e8e8;
}
.lineddd{
  height:3px;
  background-color: #e8e8e8;
  margin-top: -1px;
}
</style>



// WEBPACK FOOTER //
// src/components/Wyxf/index.vue